export const EnumPopupPositions = {
  LEFT_TOP: "LEFT_TOP",
  RIGHT_TOP: "RIGHT_TOP",
  LEFT_BOTTOM: "LEFT_BOTTOM",
  RIGHT_BOTTOM: "RIGHT_BOTTOM"
};
